import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
  VehicleDetailsService,
  VehicleDetailsServiceOptions
} from './vehicle-details.service';
import { FormFieldsModule } from '../form-fields/form-fields.module';
import { SharedModule } from '@shared/shared.module';
import { VehicleFullDetailsComponent } from './full/vehicle-full-details.component';
import { VehicleDetailsComponent } from './vehicle-details.component';

@NgModule({
  declarations: [VehicleDetailsComponent, VehicleFullDetailsComponent],
  imports: [
    CommonModule,
    FormFieldsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule
  ],
  exports: [VehicleDetailsComponent, VehicleFullDetailsComponent]
})
export class VehicleDetailsModule {
  static forRoot(
    options: VehicleDetailsServiceOptions
  ): ModuleWithProviders<VehicleDetailsModule> {
    return {
      ngModule: VehicleDetailsModule,
      providers: [
        VehicleDetailsService,
        { provide: 'options', useValue: options }
      ]
    };
  }
}
